import { useAuth } from 'components/providers/AuthProvider';
import { useFeatureFlags } from 'featureFlags/useFeatureFlags';
import { useMemo } from 'react';

type UiPermissionsResult = {
  hasStaffPermission: boolean;
  teamIdPermission: string;
};

export const useUiPermissions = (): UiPermissionsResult => {
  const { session } = useAuth();
  const { isFeatureEnabled } = useFeatureFlags();

  const hasStaffPermission = !!session?.user?.isStaff && isFeatureEnabled('is-staff-ui');

  const teamIdPermission = session?.team?.id ?? '';

  return useMemo(
    () => ({
      hasStaffPermission,
      teamIdPermission,
    }),
    [hasStaffPermission, teamIdPermission],
  );
};
